import { apiClient, getCurrentUserEmail } from "../apiClient";
import { TUser } from "../../common/types/user";
import { TResponseItemWrapper, TResponseListWrapper } from "../../common/types/common";

export const getUserList = async ({ pagination: { pageSize, pageIndex }, sorting: { sortBy, isDescending}, filtering: { searchTerm } }): Promise<TResponseListWrapper<TUser>> => {
    let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}`: '';
    if (sortBy && isDescending) {
        sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
    }

    const search = searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : '';

    return apiClient.get(`/User/GetUsers?pageSize=${encodeURIComponent(pageSize)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}`);
};

export const getUser = async (userId: string | number): Promise<TResponseItemWrapper<TUser>> => {
    return apiClient.get(`/User/GetUser?userId=${encodeURIComponent(userId)}`);
};

export const getAuthenticatedUser = async (): Promise<TResponseItemWrapper<TUser>> => {
    // FEATURE FLAG: AuthRequired bypass — include userEmail param so the API can resolve the user
    // when auth enforcement is off and no JWT email claim is present.
    const email = getCurrentUserEmail();
    const query = email ? `?userEmail=${encodeURIComponent(email)}` : '';
    return apiClient.get(`/User/GetAuthenticatedUser${query}`);
};

export const getUserByEmail = async (email): Promise<TResponseItemWrapper<TUser>> => {
    return apiClient.get(`/User/GetUserByEmail?email=${encodeURIComponent(email)}`);
};

export const createUser = async (user): Promise<TResponseItemWrapper<TUser>> => {
    // FEATURE FLAG: AuthRequired bypass — include userEmail param so the API can resolve the caller
    // when auth enforcement is off and no JWT email claim is present.
    const email = getCurrentUserEmail();
    const query = email ? `?userEmail=${encodeURIComponent(email)}` : '';
    return apiClient.post(`/User/CreateUser${query}`, user);
};

export const updateUser = async (user: TUser): Promise<TResponseItemWrapper<TUser>> => {
    return apiClient.post('/User/UpdateUser', user);
};

export const grantAdmin = async (userId: number) => {
    return apiClient.post(`/UserAdmin/GrantAdmin?userId=${encodeURIComponent(userId)}`);
};

export const revokeAdmin = async (userId: number) => {
    return apiClient.post(`/UserAdmin/RevokeAdmin?userId=${encodeURIComponent(userId)}`);
};

export const addUserAppRole = async (userEmail: string, roleName: string) => {
    return apiClient.post(`/UserAdmin/AddRole/${encodeURIComponent(userEmail)}`, { roleName });
};

export const removeUserAppRole = async (userEmail: string, roleName: string) => {
    return apiClient.post(`/UserAdmin/RemoveRole/${encodeURIComponent(userEmail)}`, { roleName });
};
